import "./technologies.css";

export function Technologies() {
  return (
    <section className="technologies">
      <ul className="technologies__ul">
        <li>Javascript - TypeScript </li>
        <li>HTML , CSS, Sass, Figma</li>
        <li>GIT</li>
        <li>ReactJS Arquitectura REDUX </li>
        <li>Mongo DB</li>
        <li>Adobe Premier, Photoshop</li>
      </ul>
      <ul className="technologies__ul">
        <li>Agile</li>
        <li>Scrum</li>
        <li>SOLID</li>
        <li>BEM </li>
        <li>Trello</li>
        <li>Discord, Slack</li>
      </ul>
    </section>
  );
}
